import { Typography } from "@mui/material"
import IconBox from "../../IconBox"
import { OperationDetailsProps } from "../props"
import {
  AccordionBody,
  AccordionHeader,
  Amount,
  ContentContainer,
  DetailContainer,
  DetailLabel,
  DetailsContainer,
  DetailsContainerTextOverflow,
  DetailValue,
  ScrollContainer,
  StatusChecked,
  StyledAccordion,
  StyledDivider,
  Subtext,
  TopContainer,
} from "../styled"
import UIIcon from "../../UIIcon"
import { formatAmount } from "../../../utils/formatters"
import { RUBLE } from "../../../utils/constants"
import { getOperationStatusDetails } from "../../../utils/operation"
import { getTimezone } from "../../../utils/datetime"

const ProviderPaymentHistoryDetails = ({
  operation,
  isRefund,
}: OperationDetailsProps) => {
  // TODO: в зависимости от группы провайдеров выводить разные поля
  // const providerGroup = operation.fields.find((f) => f.name === "ProviderGroup")
  // const masterField = operation.fields.find((f) => f.name === "MasterField")
  const paymentPurpose = operation.fields.find(
    (f) => f.name === "PaymentPurpose",
  )

  const statusDetails = getOperationStatusDetails(operation)

  const iconName = isRefund ? "incomeGrey" : "shoppingBag"

  return (
    <ContentContainer>
      <ScrollContainer>
        <TopContainer>
          <IconBox size="lg" color="yellow">
            <UIIcon
              iconName={
                statusDetails.isSuccesseful ? iconName : statusDetails.icon
              }
              size={80}
            />
          </IconBox>
          <Amount>
            {formatAmount(operation.amount)} {RUBLE}
          </Amount>
          <Subtext>
            {isRefund
              ? "Возврат оплаты товаров и услуг"
              : "Оплата товаров и услуг"}
          </Subtext>
        </TopContainer>
        <StyledDivider />
        <StyledAccordion>
          <AccordionHeader
            expandIcon={<UIIcon iconName="arrowDown" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="h4">Подробнее об операции</Typography>
          </AccordionHeader>
          <AccordionBody>
            <DetailsContainer sx={DetailsContainerTextOverflow}>
              <DetailContainer>
                <DetailLabel>Статус операции</DetailLabel>
                <DetailValue>
                  <StatusChecked statusColor={statusDetails.color}>
                    {statusDetails.message}
                  </StatusChecked>
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Номер операции в РНКО «Единая Касса»</DetailLabel>
                <DetailValue>{operation.contextOperationId}</DetailValue>
              </DetailContainer>
              {paymentPurpose?.value && (
                <DetailContainer>
                  <DetailLabel>Назначение</DetailLabel>
                  <DetailValue>{paymentPurpose?.value}</DetailValue>
                </DetailContainer>
              )}
              <DetailContainer>
                <DetailLabel>Сумма перевода</DetailLabel>
                <DetailValue>
                  {formatAmount(operation.amount)} {RUBLE}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Комиссия</DetailLabel>
                <DetailValue>
                  {formatAmount(operation.bottomCommissionAmount)} {RUBLE}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Дата и время операции</DetailLabel>
                <DetailValue>{getTimezone(operation.updatedOn)}</DetailValue>
              </DetailContainer>
            </DetailsContainer>
          </AccordionBody>
        </StyledAccordion>
      </ScrollContainer>
    </ContentContainer>
  )
}

export default ProviderPaymentHistoryDetails
